"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("baseui/button");

var _menu = _interopRequireDefault(require("baseui/icon/menu"));

var _popover = require("baseui/popover");

var _menu2 = require("baseui/menu");

var _propTypes = require("prop-types");

var _button2 = require("../button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BaseButton = {
  style: function style(_ref) {
    var $theme = _ref.$theme;
    return {
      display: 'block',
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      height: '36px',
      color: $theme.colors.white,
      ':hover': {
        backgroundColor: 'transparent'
      },
      ':focus': {
        backgroundColor: 'transparent'
      },
      ':active': {
        backgroundColor: 'transparent'
      }
    };
  }
};

var PopoverMenu = function PopoverMenu(_ref2) {
  var items = _ref2.items,
      placement = _ref2.placement,
      rest = _objectWithoutProperties(_ref2, ["items", "placement"]);

  return _react["default"].createElement(_popover.StatefulPopover, {
    placement: placement,
    content: function content(_ref3) {
      var close = _ref3.close;
      return _react["default"].createElement(_menu2.StatefulMenu, {
        items: items,
        onItemSelect: function onItemSelect(_ref4) {
          var item = _ref4.item;

          if (item.callback) {
            item.callback(rest);
          }

          close();
        }
      });
    }
  }, _react["default"].createElement(_button2.Button, {
    kind: _button.KIND.tertiary,
    overrides: {
      BaseButton: BaseButton
    }
  }, _react["default"].createElement(_menu["default"], {
    size: 36
  })));
};

exports.PopoverMenu = PopoverMenu;
PopoverMenu.propTypes = {
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  placement: _propTypes.string
};
PopoverMenu.defaultProps = {
  placement: undefined
};